import styled from 'styled-components'

export const AddOption = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`

export const Tags = styled.div`
  margin: 12px -4px -4px;
`
